import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgForbidCircleLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM14.8285 7.75747C15.219 7.36695 15.8522 7.36695 16.2427 7.75747C16.6032 8.11795 16.6309 8.68518 16.3259 9.07747L16.2427 9.17168L9.17161 16.2428C8.78109 16.6333 8.14792 16.6333 7.7574 16.2428C7.39692 15.8822 7.36919 15.3151 7.67421 14.9227L7.7574 14.8285L14.8285 7.75747Z",
		fill: "currentColor"
	})
});
export default SvgForbidCircleLine;
